import React, { Component } from "react";
import { connect } from 'react-redux';
import { checkPermission } from "@/utils/permission";
import { BellOutlined, ContainerOutlined, CustomerServiceOutlined, DeleteOutlined, DownOutlined, FolderAddOutlined, MenuOutlined } from "@ant-design/icons";
import { Dropdown, Modal, Space } from "antd";
import ServicesInterestedForm from '@/routes/customer-services/ServicesInterestedForm';
import CustomerServiceAddForm from '@/routes/customer-services/CustomerServiceAddForm';
import CustomerScheduleForm from '@/routes/customer-schedule/CustomerScheduleForm';
import CustomerCareForm from "@/components/customers/CustomerCareForm";
import { removeCustomer } from "@/redux/actions/customerActions";

const { confirm } = Modal;

class DropdownActions extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentData: null,
            isOpenAddServiceInterestedForm: false,
            isOpenAddServiceSelectedForm: false,
            isOpenScheduleForm: false,
            isOpenCustomerCareForm: false
        }
    }

    openServiceForm(record, option) {
        if (option == 'quantam') {
            this.setState({ isOpenAddServiceInterestedForm: true, currentData: record });
        } else {
            this.setState({ isOpenAddServiceSelectedForm: true, currentData: record });
        }
    }

    openScheduleForm(record) {
        this.setState({ isOpenScheduleForm: true, currentData: record });
    }

    openCustomerCareForm(record) {
        this.setState({
            isOpenCustomerCareForm: true,
            currentData: record
        });
    }


    openAlert(id) {
        confirm({
            title: 'Cảnh báo',
            content: 'Bạn chắc chắn muốn xoá khách hàng này?',
            okText: 'OK',
            cancelText: 'Huỷ',
            onOk: () => this.props.removeCustomer([id]).then(() => {
                setTimeout(() => {
                    Modal.destroyAll();
                }, 800);
                this.props.loadData();
            }),
            onCancel() { },
        })
    }

    render() {

        const {
            currentData,
            isOpenAddServiceInterestedForm,
            isOpenAddServiceSelectedForm,
            isOpenScheduleForm,
            isOpenCustomerCareForm
        } = this.state;

        const renderItems = () => {
            const itemsAction = [];
            const { record } = this.props;

            if (checkPermission('customer_schedule', 'create')) {
                itemsAction.push(
                    {
                        key: '3',
                        label: (
                            <div onClick={() => this.openScheduleForm(record)}>Lịch hẹn</div>
                        ),
                        icon: <BellOutlined />
                    },
                )
            }
            if (checkPermission('customer_services', 'create')) {
                itemsAction.push(
                    {
                        key: '4',
                        label: (
                            <div onClick={() => this.openServiceForm(record, 'quantam')}>Dịch vụ quan tâm</div>
                        ),
                        icon: <FolderAddOutlined />
                    },
                    {
                        key: '5',
                        label: (
                            <div onClick={() => this.openServiceForm(record, 'chot')}>Dịch vụ chốt</div>
                        ),
                        icon: <ContainerOutlined />
                    },
                )
            }
            if (checkPermission("customer_care_logs", "create")) {
                itemsAction.push(
                    {
                        key: '8',
                        label: (
                            <div onClick={() => this.openCustomerCareForm(record)}>Trả kết quả CSKH </div>
                        ),
                        icon: <CustomerServiceOutlined />
                    },
                )
            }
            if (checkPermission('customer', 'remove')) {
                itemsAction.push(
                    {
                        key: '9',
                        label: (
                            <div onClick={() => this.openAlert(record.id)}>Xóa khách hàng</div>
                        ),
                        icon: <DeleteOutlined />,
                        danger: true
                    }
                )
            }

            Object.keys(itemsAction).sort();
            //console.log(Object.keys(itemsAction).sort());
            return itemsAction;
        }

        const items = renderItems();

        return (
            <>
                <Space size="middle">
                    {items && items.length > 0 ? (
                        <Dropdown trigger="click" menu={{ items }}>
                            <div className='item-action-btn'>
                                <MenuOutlined /> <DownOutlined />
                            </div>
                        </Dropdown>
                    ) : (
                        <MenuOutlined style={{ color: '#dedede' }} />
                    )}
                </Space>
                <ServicesInterestedForm
                    visible={isOpenAddServiceInterestedForm}
                    currentCustomer={currentData}
                    reloadData={() => false}
                    onCancel={() => this.setState({ isOpenAddServiceInterestedForm: false })}
                />
                <CustomerServiceAddForm
                    visible={isOpenAddServiceSelectedForm}
                    currentCustomer={currentData}
                    reloadData={() => false}
                    onCancel={() => this.setState({ isOpenAddServiceSelectedForm: false })}
                />
                <CustomerScheduleForm
                    visible={isOpenScheduleForm}
                    currentCustomer={currentData}
                    reloadData={() => false}
                    onCancel={() => this.setState({ isOpenScheduleForm: false })}
                />

                <CustomerCareForm
                    visible={isOpenCustomerCareForm}
                    currentCustomer={currentData}
                    reloadData={() => this.props.loadData()}
                    editingItem={null}
                    onCancel={() => this.setState({ isOpenCustomerCareForm: false })}
                />
            </>
        );
    }
}

function mapStateToProps(state) {
    return {}
}

function mapDispatchToProps(dispatch) {
    return {
        removeCustomer: (ids) => dispatch(removeCustomer(ids)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DropdownActions);